export const UNIVERSE_TRACKING_LINK_BASE = `${process.env.REACT_APP_UNIVERSE_HOST}/cds/trackingDetail.do?&parcelNumber=`;
